import config from './config'
import Vue from 'vue'
import store from '@/store'

// axios
import axios from 'axios'

export default class Apicall {
    isloggued = false;
    return = {
        status: 'OK',
        data: null,
        msg: null,
    };

    header = {};

    getHeaders() {
        const thebearer = store.state.bearer;
        this.header = {
            headers: {
            Authorization: `Bearer ${thebearer}`,
            },
        };
        return this.header;
    }

    async isLoggedIn() {
        const thebearer = window.localStorage.getItem('bearer');
        
        if (!thebearer) {
            return false;
        } else {
            return await this.checkbearer();
        }
    }

    async checkbearer() {
        const thebearer = window.localStorage.getItem('bearer');
        const domain = config.basedomain;
        return await axios.post(`${domain}auth-client/checkbearer`, { bearer: thebearer }).then((response) => {
            if (response.data.status === 'OK') {
                store.state.userisloggued = true;
                store.state.bearer = thebearer;
                store.state.accessmode = response.data.accessmode;
                store.state.userData = response.data.userData;
                store.state.gravatar = response.data.userData.gravatar;
                return true;
            } else {
                store.state.userisloggued = false;
                store.state.bearer = '';
                window.localStorage.removeItem('bearer');
                window.localStorage.removeItem('userisloggued');
                window.localStorage.removeItem("userData");
                window.localStorage.removeItem("language");
                return false;
            }
        }).catch(() => {
            store.state.userisloggued = false;
            window.localStorage.removeItem('bearer');
            window.localStorage.removeItem('userisloggued');
            window.localStorage.removeItem("userData");
            window.localStorage.removeItem("language");
            return false;
        });
    }

    async login(username, _password) {
        const self = this;
        const domain = config.basedomain;
    
        return axios.post(`${domain}auth-client/login`, { email: username, password: _password }).then((response) => {
            self.return.bearer = response.data.token;
            window.localStorage.setItem('bearer', self.return.bearer);
            window.localStorage.setItem('userisloggued', true);
            store.state.userisloggued = true;
            store.state.bearer = self.return.bearer;
            store.state.accessmode = response.data.accessmode;
            store.state.userData = response.data.userData;
            self.return.language = response.data.language;
            store.state.gravatar = response.data.userData.gravatar;
            window.localStorage.setItem("userData",JSON.stringify(store.state.userData));
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    logout() {
        this.isloggued = false;
        store.state.userisloggued = false;
        store.state.bearer = '';
        window.localStorage.removeItem('bearer');
        window.localStorage.removeItem('userisloggued');
        window.localStorage.removeItem("userData");
        window.localStorage.removeItem("language");
        return true;
    }

    async forgotPassword(_email, _language, _hostname, _geodetails) {
        const self = this;
        const domain = config.basedomain;
    
        return axios.post(`${domain}auth-client/forgot-password`, { email: _email, language: _language, hostname: _hostname, geodetails: _geodetails }).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async checkToken(_token) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}auth-client/check-token`, { token: _token }).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async checkBurnPromo() {
        const self = this;
        const domain = config.basedomain;

        return axios.get(`${domain}auth-client/check-burn-promo`).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }


    async saveNewPassword(_token, _newPassword, _language) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}auth-client/save-new-password`, { token: _token, newpassword: _newPassword, language: _language}).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async requestLoginOtp(_method, _email, _phoneNumber, _language, _geodetails) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}auth-client/request-login-otp`, { method: _method, email: _email, phonenumber: _phoneNumber, language: _language, geodetails: _geodetails }).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async verifyLoginOTP(_token, _otp) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}auth-client/verify-login-otp`, { token: _token, otp: _otp }).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async loginWithHash(_hash, _email) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}auth-client/login-with-hash`, { hash: _hash, email: _email}).then((response) => {
            self.return.data = response.data;
            store.state.userData.loginWithHash = response.data.data.userData.loginWithHash;
            window.localStorage.setItem("userData",JSON.stringify(store.state.userData));
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async changePassword(_oldpwd, _newpwd) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}client/change-password`, { oldpassword: _oldpwd, newpassword: _newpwd}, self.getHeaders()).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            self.return.statuscode = response.response.status;
            if (response.response.status === 401) {
                this.logout();
            }
            return self.return;
        });
    }

    async getMyAccountGeneral() {
        const self = this;
        const domain = config.basedomain;
        return axios.get(`${domain}client/my-account-general`, self.getHeaders()).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            self.return.statuscode = response.response.status;
            if (response.response.status === 401) {
                this.logout();
            }
            return self.return;
        });
    }

    async updateMyAccountGeneral(_user) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}client/update-my-account-general`, _user, self.getHeaders()).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            self.return.statuscode = response.response.status;
            if (response.response.status === 401) {
                this.logout();
            }
            return self.return;
        });
    }

    async requestOTPChangeEmailPhone( _method,_email, _phoneNumber, _password, _language, _geodetails) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}client/request-otp-change-email-phone`, { method: _method, email: _email, phonenumber: _phoneNumber, password: _password, language: _language, geodetails: _geodetails }, self.getHeaders()).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            self.return.statuscode = response.response.status;
            if (response.response.status === 401) {
                this.logout();
            }
            return self.return;
        });
    }

    async verifyOTPChangeEmailPhone(_method, _token, _otp) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}client/verify-otp-change-email-phone`, { method: _method, token: _token, otp: _otp }, self.getHeaders()).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            self.return.statuscode = response.response.status;
            if (response.response.status === 401) {
                this.logout();
            }
            return self.return;
        });
    }

    async verifyChangePhoneOTP(_token, _otp) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}client/verify-change-phone-otp`, { token: _token, otp: _otp }, self.getHeaders()).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            self.return.statuscode = response.response.status;
            if (response.response.status === 401) {
                this.logout();
            }
            return self.return;
        });
    }

    async updateMyAccountNotification(_nopub, _noalert) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}client/update-my-account-notification`, { "nopub": _nopub, "noalert": _noalert}, self.getHeaders()).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            self.return.statuscode = response.response.status;
            if (response.response.status === 401) {
                this.logout();
            }
            return self.return;
        });
    }

    async updateMyAccountDisplaySignature(_displaySignature) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}client/update-my-account-display-signature`, { "displaySignature": _displaySignature}, self.getHeaders()).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            self.return.statuscode = response.response.status;
            if (response.response.status === 401) {
                this.logout();
            }
            return self.return;
        });
    }

    async updateBillingInformation(_info, _tax) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}client/update-billing-information`, { "info": _info, "tax": _tax }, self.getHeaders()).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            self.return.statuscode = response.response.status;
            if (response.response.status === 401) {
                this.logout();
            }
            return self.return;
        });
    }

    async generateApiKey() {
        const self = this;
        const domain = config.basedomain;
        return axios.get(`${domain}client/generate-api-key`, self.getHeaders()).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            self.return.statuscode = response.response.status;
            if (response.response.status === 401) {
                this.logout();
            }
            return self.return;
        });
    }

    async getUserInvoices(_params) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}client/user-invoices`, _params, self.getHeaders()).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            self.return.statuscode = response.response.status;
            if (response.response.status === 401) {
                this.logout();
            }
            return self.return;
        });
    }

    async getUserOrders(_params) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}client/user-orders`, _params, self.getHeaders()).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            self.return.statuscode = response.response.status;
            if (response.response.status === 401) {
                this.logout();
            }
            return self.return;
        });
    }

    async getMinutesAndFilesOrderedByDay(datefrom, dateto, allUsers, type, selectedData) {
        const self = this;
        const domain = config.basedomaindashboard;
        return axios.post(`${domain}client/get-minutes-and-files-ordered-by-day`, { datefrom, dateto, allUsers, type, selectedData }, self.getHeaders()).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async postSaveReviewOrderItem(_orderitemId, _reviewNote, _reviewComment) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}auth-client/save-review-item`, {orderitemId: _orderitemId, reviewNote: _reviewNote, reviewComment: _reviewComment}, self.getHeaders()).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            self.return.statuscode = response.response.status;
            if (response.response.status === 401) {
                this.logout();
            }
            return self.return;
        });
    }

    async checkUrlDownloadOriginalVideo(_orderitemId) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}auth-client/check-url-download-original-video`, {orderitemId: _orderitemId}, self.getHeaders()).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            self.return.statuscode = response.response.status;
            if (response.response.status === 401) {
                this.logout();
            }
            return self.return;
        });
    }

    async getUserList(_params) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}client/get-user-list`, _params, self.getHeaders()).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            self.return.statuscode = response.response.status;
            if (response.response.status === 401) {
                this.logout();
            }
            return self.return;
        });
    }

    async postDeleteSubAccount(_id) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}client/delete-sub-account`, {id: _id}, self.getHeaders()).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            self.return.statuscode = response.response.status;
            if (response.response.status === 401) {
                this.logout();
            }
            return self.return;
        });
    }

    async postCreateSingleSubAccount(_lastname, _firstname, _email, _cell, _role) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}client/create-single-sub-account`, {lastname: _lastname, firstname: _firstname, email: _email, cell: _cell, role: _role}, self.getHeaders()).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            self.return.statuscode = response.response.status;
            if (response.response.status === 401) {
                this.logout();
            }
            return self.return;
        });
    }

    async postCreateMultipleSubAccounts(_emailList) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}client/create-multiple-sub-accounts`, {emailList: _emailList}, self.getHeaders()).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            self.return.statuscode = response.response.status;
            if (response.response.status === 401) {
                this.logout();
            }
            return self.return;
        });
    }

    async ViewOrderWithHash(_params) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}auth-client/view-user-order-with-hash`, _params).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async reburn(_orderitemid, _burnstyle, _newPercentage, _defaultPercentage) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}auth-client/reburn-video`, { orderitemid: _orderitemid, burnstyle: _burnstyle, newPercentage: _newPercentage, defaultPercentage: _defaultPercentage }, self.getHeaders()).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async orderTranslation(_orderitemid, _language) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}auth-client/order-a-translation`, {orderitemid: _orderitemid, language: _language}).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async orderBurnVideo(_orderitemid,  _burnstyle, _newPercentage, _defaultPercentage) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}auth-client/order-burn-video`, {orderitemid: _orderitemid, burnstyle: _burnstyle, newPercentage: _newPercentage, defaultPercentage: _defaultPercentage}).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async getAvailableBurnStyles() {
        const self = this;
        const domain = config.basedomain;
        return axios.get(`${domain}auth-client/available-burn-styles`).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async cancelItem(_orderitemid) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}auth-client/cancel-item`, {orderitemid: _orderitemid}).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            return self.return;
        });
    }

    async postUpdateUserRole(_userid, _role) {
        const self = this;
        const domain = config.basedomain;
        return axios.post(`${domain}client/update-user-role`, {id: _userid, role: _role}, self.getHeaders()).then((response) => {
            self.return.data = response.data;
            return self.return;
        }).catch((response) => {
            self.return.status = 'ERROR';
            self.return.msg = response.response.data.msg;
            self.return.statuscode = response.response.status;
            if (response.response.status === 401) {
                this.logout();
            }
            return self.return;
        });
    }  

    async postProgress(orderItemId) {
        const self = this;
        const domain = config.basedomaindashboard;
        
        return axios.post(`${domain}order/progress`, { orderItemId }, self.getHeaders())
            .then((response) => {
                self.return.data = response.data;
                return self.return;
            })
            .catch((error) => {
                self.return.status = 'ERROR';
                self.return.msg = error.response.data.msg;
                return self.return;
            });
    }    

}